import request, { Response } from "superagent";

function _applyApiAuth(req, apiAuth) {
    apiAuth.verifier(); // throws if problem

    apiAuth.headers.forEach(function ([name, value]) {
        req.set(name, value);
    });

    if (apiAuth.cookies.length > 0) {
        const cookieHeaderValue = apiAuth.cookies
            .map(function ([name, value]) {
                return name + "=" + encodeURIComponent(value);
            })
            .join(";");
        req.set("Cookie", cookieHeaderValue);
    }
}

function makeRequest(apiAuth, method, url, data) {
    const fullUrl = apiAuth.baseUrl + url;
    const req = request(method, fullUrl);
    req.withCredentials();
    req.set("X-Requested-With", "XMLHttpRequest");

    try {
        _applyApiAuth(req, apiAuth);
    } catch (e) {
        return Promise.reject(e);
    }

    if (data) {
        if (method === "GET") {
            req.query(data);
        } else {
            req.send(data);
        }
    }

    return req.catch((err) => {
        // fluxible-router is checking "statusCode" instead of "status"
        err.statusCode = err.status;
        throw err;
    });
}

const DEFAULT_NUMBER_OF_RETRIES = 1;

/**
 * Try to make request - if it fails with crossDomain error, retry it
 *
 * @param apiAuth
 * @param method {string}
 * @param url {string}
 * @param data {object}
 * @param repeatable {int|bool|undefined} Can we retry request?
 *      if undefined - DEFAULT_NUMBER_OF_RETRIES will be used when method === 'GET'
 *      if true - DEFAULT_NUMBER_OF_RETRIES will be used
 *      if int - number of retries
 */
function makeRequestWithRetries(apiAuth, method, url, data, repeatable) {
    let numOfRetries = 0;

    if (
        (repeatable === undefined && method === "GET") || // auto-detect
        repeatable === true
    ) {
        // use default
        numOfRetries = DEFAULT_NUMBER_OF_RETRIES;
    }

    let promise = makeRequest(apiAuth, method, url, data);
    for (let i = 0; i < numOfRetries; i++) {
        promise = promise.catch((err) => {
            if (err.crossDomain) {
                // Retry request
                return makeRequest(apiAuth, method, url, data);
            }

            throw err; // Re-throw
        });
    }
    return promise;
}

export function get(apiAuth, url, data, repeatable?): Promise<Response> {
    return makeRequestWithRetries(apiAuth, "GET", url, data, repeatable);
}

export function post(apiAuth, url, data, repeatable?): Promise<Response> {
    return makeRequestWithRetries(apiAuth, "POST", url, data, repeatable);
}
